export default __webpack_public_path__ + "static/media/ruler-blue.2x.45d537c2.svg";